/**
 * @module components/symbols/SymbolPasswordGate
 * @summary Password prompt shown to non-manager roles before the Symbols panel.
 * @ported-from JCC PFD Engineering Tool v1.1.html lines 921-933 + tryUnlock (5259).
 */
import { useState } from 'react';
import { getSymbolPassword } from '../../lib/symbolAccess';

interface Props {
  onUnlock: () => void;
  onCancel: () => void;
}

export function SymbolPasswordGate({ onUnlock, onCancel }: Props) {
  const [pwd, setPwd] = useState('');
  const [err, setErr] = useState('');
  const tryUnlock = () => {
    if (pwd === getSymbolPassword()) onUnlock();
    else setErr('Incorrect password. Please try again.');
  };
  return (
    <div className="modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onCancel()}>
      <div className="modal-box">
        <div className="sym-pwd-icon">🔒</div>
        <div className="sym-pwd-title">Symbol Library Access</div>
        <div className="sym-pwd-sub">Enter the password to open the Symbol panel</div>
        <input
          type="password"
          placeholder="Password"
          maxLength={64}
          autoFocus
          value={pwd}
          onChange={(e) => setPwd(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') tryUnlock();
            if (e.key === 'Escape') onCancel();
          }}
        />
        <div className="sym-pwd-err">{err}</div>
        <div className="sym-pwd-row">
          <button className="sym-pwd-btn primary" onClick={tryUnlock}>
            Unlock
          </button>
          <button className="sym-pwd-btn ghost" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
